import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { WithdrawalMetadata } from './types'

export type PaymentsWithdrawalState = {
  currency?: string
  data?: WithdrawalMetadata
  fetching: boolean
  hasError: boolean
}

export const initialState: PaymentsWithdrawalState = {
  fetching: false,
  hasError: false
}

const paymentsWithdrawalSlice = createSlice({
  initialState,
  name: 'withdrawal',
  reducers: {
    error(state) {
      state.fetching = false
      state.hasError = true
    },
    fetch(state, action: PayloadAction<string>) {
      state.fetching = true
      state.currency = action.payload
    },
    reset() {
      return initialState
    },
    setMetadata(state, action: PayloadAction<WithdrawalMetadata>) {
      state.hasError = false
      state.fetching = false
      state.data = action.payload
    }
  }
})

export const { actions } = paymentsWithdrawalSlice
export default paymentsWithdrawalSlice.reducer
